'use client';
import React, { useEffect } from 'react';

function NavTop() {
  function handleScroll() {
    const bodyScroll = window.scrollY;
    const navbar = document.querySelector('.navbar');

    if (bodyScroll > 300) navbar.classList.add('nav-scroll');
    else navbar.classList.remove('nav-scroll');
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  function scrollToSection(id) {
    setTimeout(
      () =>
        document
          .querySelector(`[data-scroll-index="${id}"]`)
          ?.scrollIntoView({ smooth: true }),
      700
    );
  }

  return (
    <nav className="navbar navbar-expand-lg bord blur pt-15 pb-15">
      <div className="container d-block">
        <div className="row align-items-center">
          <div className="col-lg-4 col-6 md-hide">
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="#0"
                    data-scroll-nav="0"
                    onClick={() => scrollToSection(0)}
                  >
                    Demos
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    onClick={() => scrollToSection(1)}
                    className="nav-link"
                    href="#0"
                    data-scroll-nav="1"
                  >
                    Pages
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://uicamp.smartinnovates.net/docs/reactjs/"
                  >
                    Documentation
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-4 col-6 text-center">
            <a className="logo icon-img-120" href="#">
              <img src="/dark/assets/imgs/logo-light.png" alt="logo" />
            </a>
          </div>
          <div className="col-lg-4 col-6 d-flex">
            <div className="ml-auto">
              <a href="#0" className="butn butn-bord butn-md radius-30 fz-14">
                <span>
                  <i className="ti-shopping-cart mr-10"></i> Purchase Now
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavTop;
